<template>
    <div class="HeadlinesDetailed">
       <div class="HeadlinesDetailed-box" v-if="List.length>0">
           <div class="HeadlinesDetailed-box-title">{{List[0].title}}</div>
           <div class="HeadlinesDetailed-box-subtext"><span>发布时间：{{List[0].time}}</span>|<span>浏览次数：{{List[0].num}}</span></div>
           <div class="HeadlinesDetailed-box-dividing "></div>
           <div class="HeadlinesDetailed-box-text" v-if="List[0].text">
               <div v-html="List[0].text"></div>
           </div>
       </div>
    </div>
</template>
<script>
import {getAllNewsdetailsUrl} from '@culturalRelicsUrl';
import http from '@js/http-ww.js';
import util from '@util';
export default {
    data(){
        return {
            List:[
                {
                    title:"海南省博物馆召开11周年学术报告会",
                    time:'2019-11-19',
                    num:'115',
                    text:"为庆祝海南省博物馆建馆11周年，进一步增强学术氛围，促进学术交流，不断提升学术水平和科研能力，11月18日下午，我馆举行了建馆11周年学术报告会活动。全馆干部职工参加，会议由馆长陈江主持。 会议邀请公共服务部主任宋玉、文物考古工作队何国俊、水下考古研究所中心主任李钊、陈列部馆员黄晶、文物保护与修复部副主任包春磊等5位馆员作大会主旨发言和交流。内容涉及“十一载共成长——“我”与海南省博物馆”“从水会所城到石室仙踪——海南两处明代遗址考古简述”“近年西沙水下考古与文物保护” “灯下故人——一个德国人与海南岛的故事”““华光礁I号”南宋沉船保护历程及现状”等，报告精彩纷呈，学术氛围热烈浓郁。",
                    detailsId:"289"
                }
            ],
        }
    },
    created() {
        var {
            query:{
                id
            }
        } = this.$route;
        this.detailsId = id;
        this.List=[];
        this.getAllDetailsist()
    },
    methods: {
         //获取新闻详情
        getAllDetailsist(){
            http.get(getAllNewsdetailsUrl, { params:{id: this.detailsId}}) 
            .then(res=>{
                // console.log(res)
                const {
                    data : array = []
                } = res.data.data;
                // console.log(array)
                //请求的数据组装
                var List = [];
                List.push({
                    id:array.id,
                    title: array.title,
                    text: array.text,
                    image: array.smallImage,
                    num: array.views,
                    time:util.formatTime(new Date(array.publishDate),'yyyy-MM-dd')
                })
                this.List = List
            })
        },
    }
}   
</script>
<style lang="less" scoped>
   .HeadlinesDetailed{
       background:#f1f1f1!important;
       padding: 20px 7px 28px 7px;
        .HeadlinesDetailed-box{
            background: url(../../lib/image/news/45671.png) right bottom no-repeat;
            background-size: 262px 180px;
            background-color:rgba(255,255,255,1);
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            border-radius:5px;
            padding: 20px 24px 120px 24px;
            .HeadlinesDetailed-box-title{
                font-size: 16px;
                color:rgba(55,83,106,1);
                line-height: 24px;
                font-weight:500;
                text-align: center;
            }
            .HeadlinesDetailed-box-subtext{
                font-weight:400;
                color:rgba(95,106,109,1);
                font-size: 12px;
                text-align: center;
                padding-top: 10px;
                span{
                    font-weight:400;
                    color:rgba(95,106,109,1);
                    font-size: 12px; 
                    padding: 0 4px;
                }
            }
            .HeadlinesDetailed-box-dividing{
                height: 14px;
                background: url(../../lib/image/IntroductoryArticles/top.png) center no-repeat;
                background-size: 100% 100%;
                margin: 32px 0 24px 0;
            }
            .HeadlinesDetailed-box-text{
                text-align: justify; 
                text-justify: inter-ideograph; 
                text-indent: 2em;
                padding-top: 15px;
                font-size:12px;
                font-weight:400;
                color:#757C88;
                line-height:18px;
                .HeadlinesDetailed-img{
                    height: 195px;
                    width: 100%;
                }
            }
        }
   }
</style>